import { Injectable } from '@angular/core';
import { DetailedUser, SearchQuery, SearchResponse, TreeUser, TreeUserResponse } from '../model/users-model';
import { UsersApiService } from './users-api.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UsersStore {
  private _DetailedUserObserver: BehaviorSubject<DetailedUser> = new BehaviorSubject(undefined);

  constructor(private usersApiService: UsersApiService) {}

  public setDetailedUser(item: DetailedUser) {
    this._DetailedUserObserver.next(item);
  }

  public DetailedUserObserver(): Observable<DetailedUser> {
    return this._DetailedUserObserver.asObservable();
  }

  public loadUsers(request: SearchQuery): Promise<SearchResponse> {
    return new Promise<SearchResponse>((resolve, reject) => {
      this.usersApiService
        .getUsersQuery(request)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              resolve(data);
            } else reject(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getUserTreeHierarchy(userData: TreeUser): Promise<TreeUserResponse> {
    return new Promise<TreeUserResponse>((resolve, reject) => {
      this.usersApiService
        .getUserHierarchy(userData)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              resolve(data);
            } else reject(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }
}
